import React from "react";

function formatDate(dateStr) {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
}

function formatTime(timeStr) {
  if (!timeStr) return "-";
  let [hour, minute] = timeStr.split(":");
  hour = parseInt(hour, 10);
  const ampm = hour >= 12 ? "pm" : "am";
  hour = hour % 12;
  if (hour === 0) hour = 12;
  return `${hour}:${minute} ${ampm}`;
}

const BasicsInfo = ({ date, time, language, days }) => {
  // Function to format days display
  const formatDaysDisplay = (days) => {
    if (!days) return "Live Interactive Session";

    // If days is a number, format it as "X Days"
    if (!isNaN(days) && days > 0) {
      return `${days} Days Live Interactive Session`;
    }

    // If days is a string, use it as is
    return `${days} Live Interactive Session`;
  };

  return (
    <div>
      <ul className="mt-4 text-lg">
        <h4
          style={{ fontFamily: "Josefin Sans, sans-serif" }}
          className="text-xl text-slate-800 text-center extraBold"
        >
          More Info:
        </h4>
        <li className="mt-4">
          ✅ Suitable for any beginners, college students & working professional
        </li>
        <li className="mt-4">
          <span className="font-semibold ">📆 Date : </span>
          <button className="border border-[#7620ff] bg-[#7620ff] text-white p-1 rounded-md px-2  ">
            {formatDate(date)}
          </button>
        </li>
        <li className="mt-4">
          <span className="font-semibold ">⏰ Time : </span>
          <button className="border border-[#7620ff] bg-[#7620ff] text-white p-1 rounded-md px-2  ">
            {formatTime(time)}
          </button>
        </li>
        <li className="mt-4">
          <span className="font-semibold ">🔔 Lang : </span>
          <button className="border border-[#7620ff] bg-[#7620ff] text-white p-1 rounded-md px-2  ">
            {language ? `in ${language}` : "-"}
          </button>
        </li>
        <li className="mt-4">🎥 {formatDaysDisplay(days)}</li>
        <li className="mt-4">🕹️ Recordings & notes are provided</li>
        <li className="mt-4">
          📲 Free guidance on demat account opening & mobile app demo
        </li>
        <li className="mt-4">✅ WhatsApp community for free </li>
      </ul>
    </div>
  );
};

export default BasicsInfo;
